import { render, staticRenderFns } from "./login.vue?vue&type=template&id=563e2944&scoped=true&"
var script = {}
import style0 from "./login.vue?vue&type=style&index=0&id=563e2944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e2944",
  null
  
)

export default component.exports